'use strict';exports.__esModule = true;exports.removeMultitouchGestures = exports.addMultitouchGestures = exports.calculateArrowPosition = exports.calculateInfoWindowPosition = exports.getDistanceBetweenPointAndMapBorders = exports.makeGeoJsonPolygon = exports.makeGeoJsonFeature = exports.getPinIcon = undefined;var _createCustomMapPin = require('../../utils/createCustomMapPin');var _createCustomMapPin2 = _interopRequireDefault(_createCustomMapPin);
var _constants = require('../../constants');


var _constants2 = require('./constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getPinIcon = exports.getPinIcon = function getPinIcon(type) {
  var lastChar = Math.abs(parseInt(type.substr(-2, 2), 10));
  var num = isNaN(lastChar) ? 0 : lastChar;

  switch (type) {
    case _constants2.PIN_TYPES.PROPERTY:return (0, _createCustomMapPin2.default)(0, 'property');
    case _constants2.PIN_TYPES['PROPERTY_' + num]:return (0, _createCustomMapPin2.default)(num, 'property');
    case _constants2.PIN_TYPES['PROJECT_' + num]:return (0, _createCustomMapPin2.default)(num, 'project');
    case _constants2.PIN_TYPES.FAVORITE:return (0, _createCustomMapPin2.default)(0, 'favorite');
    case _constants2.PIN_TYPES.PROJECT:return (0, _createCustomMapPin2.default)(0, 'project');
    case _constants2.PIN_TYPES.PROPERTY_REVIEWED:return (0, _createCustomMapPin2.default)(0, 'property', false, true);
    case _constants2.PIN_TYPES['PROPERTY_REVIEWED_' + num]:return (0, _createCustomMapPin2.default)(num, 'property', false, true);
    case _constants2.PIN_TYPES['PROJECT_REVIEWED_' + num]:return (0, _createCustomMapPin2.default)(num, 'project', false, true);
    case _constants2.PIN_TYPES.FAVORITE_REVIEWED:return (0, _createCustomMapPin2.default)(0, 'favorite', false, true);
    case _constants2.PIN_TYPES.PROJECT_REVIEWED:return (0, _createCustomMapPin2.default)(0, 'project', false, true);
    case _constants2.PIN_TYPES.AGENCY:return (0, _createCustomMapPin2.default)(0, 'agency');
    default:return (0, _createCustomMapPin2.default)(0, 'property');}

};

var makeGeoJsonFeature = exports.makeGeoJsonFeature = function makeGeoJsonFeature(lng, lat, properties) {return {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [lng, lat] },

    properties: Object.assign({},
    properties) };};



var makeGeoJsonPolygon = exports.makeGeoJsonPolygon = function makeGeoJsonPolygon(polygon) {return {
    type: 'Feature',
    geometry: {
      type: 'MultiPolygon',
      coordinates: polygon } };};



var getDistanceBetweenPointAndMapBorders = exports.getDistanceBetweenPointAndMapBorders = function getDistanceBetweenPointAndMapBorders(map, point, mapHeightPixel, mapWidthPixel) {
  var mapBounds = map.getBounds();
  var mapNEPoint = mapBounds.getNorthEast();
  var mapSWPoint = mapBounds.getSouthWest();
  var mapHeight = mapSWPoint.lat - mapNEPoint.lat;
  var mapWidth = mapNEPoint.lng - mapSWPoint.lng;
  var pointOffsetTop = point.lat - mapNEPoint.lat;
  var pointOffsetLeft = point.lng - mapSWPoint.lng;
  var pointOffsetRight = mapNEPoint.lng - point.lng;

  var distancesInPixel = {
    top: pointOffsetTop * mapHeightPixel / mapHeight,
    left: pointOffsetLeft * mapWidthPixel / mapWidth,
    right: pointOffsetRight * mapWidthPixel / mapWidth };


  return distancesInPixel;
};

var calculateInfoWindowPosition = exports.calculateInfoWindowPosition = function calculateInfoWindowPosition(pinOffsets, infoWindowHeight, infoWindowWidth) {var

  arrowHeight = _constants.mapboxPinInfoWindowMetrics.ARROW_HEIGHT,
  defaultOffsetY = _constants.mapboxPinInfoWindowMetrics.DEFAULT_OFFSET_Y,
  reverseOffsetY = _constants.mapboxPinInfoWindowMetrics.REVERSE_OFFSET_Y,
  margin = _constants.mapboxPinInfoWindowMetrics.MARGIN;


  var offsetX = infoWindowWidth / 2;
  var offsetY = defaultOffsetY - infoWindowHeight;
  var isArrowAtTop = false;

  if (pinOffsets.top < infoWindowHeight + arrowHeight - defaultOffsetY) {
    isArrowAtTop = true;
    offsetY = arrowHeight + reverseOffsetY;
  }

  if (pinOffsets.left < infoWindowWidth / 2 + margin) {
    offsetX = pinOffsets.left - infoWindowWidth / 2 - margin + infoWindowWidth / 2;
  }

  if (pinOffsets.right < infoWindowWidth / 2 + margin) {
    offsetX = infoWindowWidth / 2 + margin - pinOffsets.right + infoWindowWidth / 2;
  }

  return {
    isArrowAtTop: isArrowAtTop,
    offsetX: offsetX,
    offsetY: offsetY };

};

var calculateArrowPosition = exports.calculateArrowPosition = function calculateArrowPosition(mapWidth, infoWindowWidth, pinOffsetLeft, infoWindowOffsetX) {
  var margin = (mapWidth - infoWindowWidth) / 2;
  var arrowOffsetLeft = window.screen.width < 768 ? pinOffsetLeft - margin : infoWindowOffsetX;

  return arrowOffsetLeft - _constants.mapboxPinInfoWindowMetrics.ARROW_WIDTH / 2 + 'px';
};

var isTouchEvent = function isTouchEvent(evt) {return evt.originalEvent && 'touches' in evt.originalEvent;};
var isTwoFingerTouch = function isTwoFingerTouch(evt) {return evt.originalEvent.touches.length >= 2;};

var handleDrugStart = function handleDrugStart(event) {
  if (isTouchEvent(event) && !isTwoFingerTouch(event)) {
    var map = event.target;
    map.dragPan.disable();
  }
};

var handleTouchstart = function handleTouchstart(event) {
  if (isTouchEvent(event) && isTwoFingerTouch(event)) {
    var map = event.target;
    map.dragPan.enable();
  }
};

var addMultitouchGestures = exports.addMultitouchGestures = function addMultitouchGestures(map) {
  map.dragPan.disable();

  map.on('dragstart', handleDrugStart);
  // Drag events not emited after dragPan disabled, so I use touch event here
  map.on('touchstart', handleTouchstart);
};

var removeMultitouchGestures = exports.removeMultitouchGestures = function removeMultitouchGestures(map) {
  map.off('dragstart', handleDrugStart);
  map.off('touchstart', handleTouchstart);
};


//////////////////
// WEBPACK FOOTER
// ./src/services/MapboxService/helpers.js
// module id = 288
// module chunks = 0